<div class="overlay">
    <div @click="onClose" class="w32 h32 bg-primary rounded absolute-top-right mt24 mr24 pointer" style="z-index:9">
        <i class="fa fa-times absolute-center txt-white font18"></i>
    </div>

    <c-loading v-show="!isImageLoaded" class="absolute-center"></c-loading>
    <img v-show="isImageLoaded" :src="src" class="absolute-center img-src" @load="onImgLoad" />
</div>